import { getAnalytics, isSupported, logEvent, setUserId, type Analytics } from 'firebase/analytics';
import { app } from './firebase';

// Firebase Analytics (GA4). Initializing it enables the Realtime "users online"
// report automatically; the custom events below track the game funnel so you can
// see how many rooms are created and how many games are played/finished.
//
// Where to look: Firebase Console → Analytics → Realtime / Events, or the linked
// GA4 property (measurementId G-3GGPG6106L).

let analytics: Analytics | null = null;
let ready = false;
let pendingUid: string | null = null;
const queue: Array<[string, Record<string, unknown> | undefined]> = [];

// isSupported() guards environments where Analytics can't run (some webviews,
// SSR, private modes). Events fired before init are queued, not dropped.
isSupported()
  .then((ok) => {
    if (!ok) return;
    analytics = getAnalytics(app);
    ready = true;
    if (pendingUid) setUserId(analytics, pendingUid);
    for (const [event, params] of queue) logEvent(analytics, event, params);
    queue.length = 0;
  })
  .catch(() => {
    /* analytics unavailable — no-op */
  });

export function track(event: string, params?: Record<string, unknown>): void {
  if (ready && analytics) logEvent(analytics, event, params);
  else queue.push([event, params]);
}

export function identify(uid: string): void {
  pendingUid = uid;
  if (ready && analytics) setUserId(analytics, uid);
}
